export default class TemplateValidation{

    constructor(validationRules, form_element = '#crud_form', display_valid_fields = false) {
        this.validationRules = validationRules;
        this.form_element = form_element;
        this.display_valid_fields = display_valid_fields
        this.validation = null;

        this.addCustomValidations();
        this.initValidation();
    }

    onDestroy(){
        if(this.validation !== undefined && this.validation !== null){
            this.validation.destroy();
        }
    }

    addCustomValidations() {

        // Validate french phone number: 10 chars type numbers ignoring spaces
        $.validator.addMethod("phone_number_fr", function( value, element ) {
            let val = value.replace(/ /g, '');
            return val.match(/[0-9]/g) && value.replace(/ /g, '').length === 10 && (value.charAt(0) === "0");
        }, I18n.t('common.js_validation.phone_number_fr'));

        // Validate passwords: 8 to 70 chars containing at least 1 majus, 1 minus, 1 number and 1 special char
        $.validator.addMethod("password_validation", function( value, element ) {
            if ( value === undefined || value === '' ){
                return true;
            }
            return value.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*()_+{}|:<>?\/~`\-=\[\]';.,]).{8,70}$/g) && value.length >= 8;
        }, I18n.t('common.js_validation.password_validation'));

        // Validate correct email: {some_chars}@{some_chars}.{2 to 4 chars}
        $.validator.addMethod("email_validation", function( value, element ) {
            return  value.match(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);
        }, I18n.t('common.js_validation.email_validation'));

        // Validate wysiwyg max content: 255 max
        $.validator.addMethod("wysiwyg_255", function( value, element ) {
            let n_characters = (value !== '' ? value.length : 0)
            return  n_characters < 255;
        }, I18n.t('common.js_validation.wysiwyg_255_validation'));

        // Validate neph code: 12 chars type numbers
        $.validator.addMethod("neph", function( value, element ) {
            if( value === '') { return true }
            return value.match(/[0-9]/g) && value.length === 12;
        }, I18n.t('common.js_validation.neph'));

        // Caution, the validation is done on the postal code field but the rule is applied on the address postal code field which is an hidden field filled by the autocomplete
        $.validator.addMethod("postal_code_validation", function( value, element ) {
            return  $("#customer_address_postal_code").val().length>0
        }, I18n.t('common.js_validation.postal_code_validation'));

        $.validator.addMethod("name_validation", function (value, element) {
            if (this.optional(element)) return true;
            return /^[\p{L} :\-']+$/u.test(value);
        }, I18n.t('common.js_validation.characters_invalid'));

        $.validator.addMethod("greater_than", function(value, element, params) {
            let $paramEl = $(params);
            if ($paramEl.val() !== '') {
                if (!/Invalid|NaN/.test(new Date(value))) {
                    return new Date(value) > new Date($paramEl.val());
                }
                return isNaN(value) && isNaN($paramEl.val()) || (Number(value) > Number($paramEl.val()));
            }
            return true;
        },I18n.t('common.js_validation.greater_than'));

        $.validator.addMethod("unique_code_option", function(value, element, params) {
            let $paramEl = $(element);
            let $optionContainer = $("#option_card");
            let $optionInputs = $optionContainer.find('input[name*="code"]');
            let $optionValues = $optionInputs.map(function() { return this.value; }).get();

            let $optionValuesUnique = $optionValues.filter(function(item, pos) {
                return item === $paramEl.val()
            })
            return $optionValuesUnique.length === 1;
        }, I18n.t('common.js_validation.unique_code_option'));

        $.validator.addMethod("responsible_email_different", function(value, element, param) {
            // Check if the value of the current field is different from the value of the other field
            console.log("responsible_email_different called");
            console.log(value);
            console.log("----");
            console.log($(param).val());
            return this.optional(element) || value !== $(param).val();
        }, "L'email du responsable légal doit être différent du vôtre.");

        // Validate minimum age based on formula type
        $.validator.addMethod("min_age_validation", function(value, element) {
            if (!value) return true; // Let required validation handle empty values
            
            const birthDate = new Date(value);
            const today = new Date();
            const isAcc = $(element).data('is-acc') === true;
            const minAge = isAcc ? 15 : 16;
            
            // Calculate age
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            
            // Check if age is reasonable (not over 100)
            if (age > 100) {
                return false;
            }
            
            return age >= minAge;
        }, function(params, element) {
            const birthDate = new Date($(element).val());
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            
            // Return appropriate message based on age
            if (age > 100) {
                return "Auriez-vous fait une erreur dans la date ? Passer son permis après 100 ans, pourquoi pas...";
            }
            
            const isAcc = $(element).data('is-acc') === true;
            return isAcc ? 
                "Vous devez avoir 15 ans minimum pour vous inscrire à la conduite accompagnée" : 
                "Vous devez avoir 16 ans minimum pour vous inscrire à la formule choisie";
        });
    }

    initValidation() {
        let options = {
            focusCleanup: false,
            rules: this.validationRules,
            validClass: "is-valid",
            errorClass: "is-invalid",
            errorElement: "span",
            errorPlacement: this.errorPlacement,
            highlight: this.highlight,
            unhighlight: this.unhighlight,
            ignore: "[contenteditable='true']:not([name]), :hidden",
            // Override to prevent form submission on validation errors
            submitHandler: function(form) {
                form.submit();
            }
        }

        if(I18n.locale !== 'en'){
            options.messages = require('jquery-validation/dist/localization/messages_'+I18n.locale);
            // Override the max message specifically for birth date
            if (!options.messages['customer[birth_date]']) {
                options.messages['customer[birth_date]'] = {};
            }
        }
        
        this.validation = $(this.form_element).validate(options);
    }

    errorPlacement(error, element) {
        if(element.data('error-after') !== null && element.data('error-after') !== undefined){
            $(element.data('error-after')).after(error);
        } else {
            error.appendTo(element.parent());
        }
    }

    highlight = (element, errorClass, validClass) => {
        let element_id = $(element).addClass(errorClass).attr('id');

        if (this.display_valid_fields) {
            $(element).removeClass(validClass);
        }
        $('label[for='+ element_id +']').addClass('text-danger');
    }

    unhighlight = (element, errorClass, validClass) => {
        let element_id = $(element).removeClass(errorClass).attr('id');
        if (this.display_valid_fields) {
            $(element).addClass(validClass);
        }
        $('label[for='+ element_id +']').removeClass('text-danger');
    }
}